module.exports = __webpack_public_path__ + "static/media/next-icon-hot-tea-o.c6de335e.svg";